module.exports = __webpack_public_path__ + "img/avp_bck_alt_phablet@2x.340d500.jpg";